"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utils_1 = require("@/utils");
const BASE_URL = {
    test: 'https://test.api.oneweb.mercedes-benz.com/fcis-calculation-api/v1',
    production: 'https://api.oneweb.mercedes-benz.com/fcis-calculation-api/v1',
    development: 'https://dev.api.oneweb.mercedes-benz.com/fcis-calculation-api/v1',
};
class FcisCalculationApi {
    constructor() {
        this.market = '';
        this.language = '';
        this.baseUrl = '';
    }
    setConfig(market, language, environment) {
        this.market = market;
        this.language = language;
        const base = BASE_URL[environment] || BASE_URL['production'];
        this.baseUrl = `${base}`;
    }
    fetchVehicleCosts(combinedElectricConsumption, combinedGasConsumption, combinedCo2Emission, engineCapacity, fuelType, engineConcept) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const urlPrefix = `${this.baseUrl}/vehicle/costs/envkv/${this.market}/${this.language}?`;
            let extraConsumptionParams = '';
            if ((0, utils_1.isElectricCCS)(engineConcept)) {
                // Electric vehicle scenario
                extraConsumptionParams = `combinedElectricConsumption=${combinedElectricConsumption}`;
            }
            else if ((0, utils_1.isHybridCCS)(engineConcept)) {
                // Hybrid vehicle scenario
                extraConsumptionParams = `combinedGasConsumption=${combinedGasConsumption}&combinedElectricConsumption=${combinedElectricConsumption}&engineCapacity=${engineCapacity}`;
            }
            else {
                // Combustion engine scenario
                extraConsumptionParams = `combinedGasConsumption=${combinedGasConsumption}&engineCapacity=${engineCapacity}`;
            }
            const url = `${urlPrefix}${extraConsumptionParams}&combinedCo2Emission=${combinedCo2Emission}&fuelType=${fuelType}&engineConcept=${engineConcept}`;
            try {
                const response = yield fetch(url);
                const result = yield response.json();
                return this.mapEnvkvResponse(result);
            }
            catch (error) {
                console.error('Error fetching vehicle costs from FCIS Calculation API:', error);
                throw error;
            }
        });
    }
    getVehicleList(config) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const category = config.category;
            const applicationType = config.applicationType;
            const engineConcept = config.engineConcept;
            const queryParams = {
                modelSeries: config.modelSeries || null,
                subBrand: config.subBrand || null,
                productGroups: config.productGroups.join(','),
            };
            // remove queryparams null
            Object.keys(queryParams).forEach((key) => !queryParams[key] && delete queryParams[key]);
            const queryParamsString = new URLSearchParams(queryParams).toString();
            const url = `${this.baseUrl}/vehicle-list/${category}/${this.market}/${this.language}?${queryParamsString}`;
            const response = yield fetch(url);
            const result = yield response.json();
            if (applicationType === 'single') {
                if (((_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.modelSeriesVehicles) === null || _b === void 0 ? void 0 : _b.vehicles) && engineConcept) {
                    result.data.modelSeriesVehicles.vehicles = result.data.modelSeriesVehicles.vehicles.filter(({ technicalData: { engine } }) => engine.engineConcept === engineConcept);
                }
                return ((_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.modelSeriesVehicles) || [];
            }
            return ((_d = result === null || result === void 0 ? void 0 : result.data) === null || _d === void 0 ? void 0 : _d.classBodytypeVehicles) || [];
        });
    }
    mapEnvkvResponse(response) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        const vehicleTaxes = response.vehicleTaxes;
        const energyCost = response.energyCost;
        const co2Costs = response.co2Costs;
        const calculationConstants = response.calculationConstants;
        return {
            carTax: {
                co2tax: (_a = vehicleTaxes === null || vehicleTaxes === void 0 ? void 0 : vehicleTaxes.co2Tax) === null || _a === void 0 ? void 0 : _a.value,
                engineCapacityTax: (_b = vehicleTaxes === null || vehicleTaxes === void 0 ? void 0 : vehicleTaxes.engineCapacityTax) === null || _b === void 0 ? void 0 : _b.value,
                totalTax: (_c = vehicleTaxes === null || vehicleTaxes === void 0 ? void 0 : vehicleTaxes.totalTax) === null || _c === void 0 ? void 0 : _c.value,
                currency: ((_d = vehicleTaxes === null || vehicleTaxes === void 0 ? void 0 : vehicleTaxes.co2Tax) === null || _d === void 0 ? void 0 : _d.unit) || ((_e = vehicleTaxes === null || vehicleTaxes === void 0 ? void 0 : vehicleTaxes.engineCapacityTax) === null || _e === void 0 ? void 0 : _e.unit) || ((_f = vehicleTaxes === null || vehicleTaxes === void 0 ? void 0 : vehicleTaxes.totalTax) === null || _f === void 0 ? void 0 : _f.unit),
            },
            energyCost: energyCost === null || energyCost === void 0 ? void 0 : energyCost.value,
            co2cost: {
                low: (_g = co2Costs === null || co2Costs === void 0 ? void 0 : co2Costs.low) === null || _g === void 0 ? void 0 : _g.value,
                middle: (_h = co2Costs === null || co2Costs === void 0 ? void 0 : co2Costs.middle) === null || _h === void 0 ? void 0 : _h.value,
                high: (_j = co2Costs === null || co2Costs === void 0 ? void 0 : co2Costs.high) === null || _j === void 0 ? void 0 : _j.value,
                currency: ((_k = co2Costs === null || co2Costs === void 0 ? void 0 : co2Costs.low) === null || _k === void 0 ? void 0 : _k.unit) || ((_l = co2Costs === null || co2Costs === void 0 ? void 0 : co2Costs.middle) === null || _l === void 0 ? void 0 : _l.unit) || ((_m = co2Costs === null || co2Costs === void 0 ? void 0 : co2Costs.high) === null || _m === void 0 ? void 0 : _m.unit),
            },
            baseData: {
                energyCostBaseDate: calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.energyCostBaseYear,
                co2priceValidityFromDate: calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.co2PriceValidityFromYear,
                co2priceValidityToDate: calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.co2PriceValidityToYear,
                avgFuelPricesPer100km: {
                    SUPER: (_o = calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.avgFuelPrice) === null || _o === void 0 ? void 0 : _o.value,
                    SUPERPLUS: (_p = calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.avgFuelPrice) === null || _p === void 0 ? void 0 : _p.value,
                    SUPER_E10: (_q = calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.avgFuelPrice) === null || _q === void 0 ? void 0 : _q.value,
                    DIESEL: (_r = calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.avgFuelPrice) === null || _r === void 0 ? void 0 : _r.value,
                    ELECTRIC: (_s = calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.avgElectricityPrice) === null || _s === void 0 ? void 0 : _s.value,
                },
                averageKilometersPerYear: (_t = calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.avgDistancePerYear) === null || _t === void 0 ? void 0 : _t.value,
                co2pricesPerTon: {
                    low: (_v = (_u = calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.co2Prices) === null || _u === void 0 ? void 0 : _u.low) === null || _v === void 0 ? void 0 : _v.value,
                    middle: (_x = (_w = calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.co2Prices) === null || _w === void 0 ? void 0 : _w.middle) === null || _x === void 0 ? void 0 : _x.value,
                    high: (_z = (_y = calculationConstants === null || calculationConstants === void 0 ? void 0 : calculationConstants.co2Prices) === null || _y === void 0 ? void 0 : _y.high) === null || _z === void 0 ? void 0 : _z.value,
                },
            },
        };
    }
}
const fcisCalculationApi = new FcisCalculationApi();
exports.default = fcisCalculationApi;
